export default __webpack_public_path__ + "static/project-slide-4-2016-765-1c63144af21b7305db79ed6d7a6b220d.jpg";